<template>
  <div>
    <v-row no-gutters align="end">
      <v-img id="image" gradient="rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.8)" src="@/assets/images/gazszallitas2.jpg">
        <template v-slot:placeholder>
          <v-row
          class="fill-height ma-0"
          align="center"
          justify="center"
          >
            <v-progress-circular
                indeterminate
                color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
          <v-row no-gutters class="fill-height" justify="center" >
            <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="11" md="10" lg="6" align-self="end"><h1 class="white--text" style="font-size:6rem;">Cégismertető</h1></v-col>
            <v-col v-else cols="11" md="10" lg="6" align-self="end"><h1 class="white--text" style="font-size:3.5rem;">Cégismertető</h1></v-col>
          </v-row>
      </v-img>
    </v-row>
    <v-row no-gutters justify="center" class="my-5">
      <v-col cols="11" md="10" lg="6">
        <h2 class="subtitle">Cégünk történelme</h2>
        <p>BNS Mérnökiroda Kft jogelődje 1998-ban alakult Brain-Box Gáz és Méréstechnológiai Kft néven. 1999-ben a Brain-Box Kft tulajdonosi
        szerkezetében történt változást követően, a tulajdonosok, a cég átalakításáról döntöttek, így 1999. február 26.-án új névvel
        megalakították a BNS Mérnökiroda Kft-t.</p>
        <p>BNS Mérnökiroda Kft létszáma 5fő, ebből 4fő egyetemi vagy főiskolai diplomával,
        1fő pedig középfokú végzettséggel rendelkezik, ennek megfelelően, cégünk
        magas szintű műszaki szakmaiságát folyamatosan biztosítják.</p>
        <h2 class="subtitle">Cégünk tevékenysége</h2>
        <p>Vállalkozásunk tevékenységeit elsősorban a műszerezés, automatizálás és
        számítástechnika, valamint a villamosipari rendszerek tervezési, szerelési
        területein folytatja.</p>
        <p>E területeken belül szakismeretei kiterjednek a felügyeleti-, működtető-, telemechanika,
        energiaellátó-, energia elosztó-, villámvédelmi-, biztonsági rendszerekre, e komplex
        rendszereket alkotó számos készülékre, berendezésre, a szakági előírásoknak és
        szabványoknak mindenkor megfelelő kialakítások lehetőségeire, és létesítésük gyakorlati
        eljárásaira - beleértve a tűz- és robbanásveszélyes környezetben történő alkalmazásokat is.</p>
        <p>Cégünk - a MOL Csoport elvárásainak megfelelő - szakmai tapasztalatait az alakulás óta
        eltelt tizenegy éves aktív és sikeres működés időszakában szerezte. Ezt bizonyítják a MOL
        Csoport különböző üzemeiben végzett szerelés-kivitelezés, illetve tervezés munkáink.</p>
        <h2 class="subtitle">ISO 9001 Minősítés</h2>
        <p class="mb-1">A BNS Mérnökiroda Kft az ISO 9001:2008 szabvány követelményei szerint alakította ki minőségirányítási rendszerét.</p>
        <v-btn outlined to="/iso" class="mb-5" color="#920825">Bővebben</v-btn>
        <h2 class="subtitle">Cég adatok</h2>
        <v-row
          v-for="i in lists"
          :key="i"
          :title="i"
          class="my-2 ml-0"
        >
          <p class="ma-0"><v-icon style="color:#920825">mdi-chevron-right</v-icon>{{i}}</p>
        </v-row>
        <v-row
          v-for="i in lists2"
          :key="i"
          :title="i"
          class="my-2 ml-0"
        >
          <p class="ma-0"><v-icon style="color:#920825">mdi-chevron-right</v-icon>{{i}}</p>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'About',
  data(){
    return{
      lists:[
        "Cég neve: BNS MÉRNÖKIRODA Korlátolt Felelősségű Társaság",
        "Telephelyi iroda: H-1131 Budapest, Szent László u. 184. II/16.",
        "Postacíme: H-1131 Budapest, Szent László u. 184. II/16.",
      ],
      lists2:[
        "Cég jogi státusza: Korlátolt Felelősségű Társaság",
        "Alapításának időpontja: 1999. február 26.",
        "Cégjegyzékszáma: 01-09-680175",
        "Bejegyzés helye, ideje: Budapest, 1999. június 10.",
        "Adószáma: 12386484-2-41"
      ]
    }
  }
}
</script>

<style scoped>
  #image{
    height:250px;
  
  }
  #title{
    font-size: 7rem;
  }
  #title2{

    font-size: 2rem;
  }
  .subtitle{
    color:#920825;
  }
  .title_bar{
    background-color: #920825;
    color: white;
  }
  .container{
    background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.8))
  }
</style>